<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <!-- class="body-content-overlay" -->
    <div
      :class="{
        show:
          shallShowUserProfileSidebar ||
          shallShowActiveChatContactSidebar ||
          mqShallShowLeftSidebar,
      }"
      @click="
        mqShallShowLeftSidebar =
          shallShowActiveChatContactSidebar =
          shallShowUserProfileSidebar =
            false
      "
    />

    <!-- Main Area -->
    <section class="chat-app-window">
      <!-- Chat Content -->
      <div v-if="activeChat" class="active-chat">
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">
            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">
              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>
              <b-avatar
                v-if="activeChat.fullName"
                size="36"
                class="badge-minimal mr-1"
                badge-variant="success"
                variant="light-dark"
              >
                <feather-icon icon="UserIcon" size="36" />
              </b-avatar>
              <h6 class="mb-0">
                {{ activeChat.fullName }}
              </h6>
            </div>
          </header>
        </div>
        <!-- User Chat Area DESCOMENTAR -->

        <chat-log
          :chat-data="sortedChatData"
          :profile-user-avatar="activeChat.avatar"
          :is-auto-refreshing="isRefreshingMessages"
          :loading-chat="loadingChat"
          :current-page-message="currentPageMenssage"
          :total-pages-message="totalPagesMessage"
          :loading-more-messages="loadingMoreMessages"
          :all-messages-loaded="allMessagesLoaded"
          @load-newer-messages="loadNewerMessages"
        />

        <!-- Message InputAdd commentMore actions -->
        <input-chat
          v-if="idConversation"
          :chat-input-message="chatInputMessage"
          @send-message="addMessage"
        />
      </div>
    </section>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :chats-contacts="[]"
        :contacts="contacts"
        :total-pages-contact="totalPagesContact"
        :current-page-contact="currentPageContact"
        :all-contacts-loaded="allContactsLoaded"
        :loading-contacts="loadingContacts"
        :active-chat-contact-id="idConversation"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :profile-user-minimal-data="profileUserDataMinimal"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        :is-refreshing-contacts="isRefreshingContacts"
        @show-user-profile="false"
        @load-more-contacts="getContacts"
        @open-chat="openChatOfContact"
        @filter-contacts="filterContacts"
      />
    </portal>
  </div>
</template>

<script>
import _ from "lodash";
import store from "@/store";
import { ref, onUnmounted, nextTick } from "@vue/composition-api";
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";
import ChatLeftSidebar from "./ChatLeftSidebar.vue";
import chatStoreModule from "./chatStoreModule";
import ChatActiveChatContentDetailsSidedbar from "./ChatActiveChatContentDetailsSidedbar.vue";
import ChatLog from "./ChatLog.vue";
import InputChat from "./InputChat.vue";
import {
  getConversations,
  getMessages,
  sendMessage,
  sendMessageImage,
} from "@core/api/request/conversations";
import { postFile } from "@/@core/api/request";
import useChat from "./useChat";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { createSignalRConnection } from "@core/api/request/signalr";
import * as signalR from "@microsoft/signalr";
import * as moment from "moment";
import "moment/locale/es";
import "moment-timezone";

export default {
  components: {
    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ChatLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatLog,
    InputChat,
  },
  data: () => ({
    companyGuid: null,

    shallShowUserProfileSidebar: false,
    profileUserData: {},
    profileUserDataMinimal: {},
    mqShallShowLeftSidebar: true,

    // SignalR
    contactsConnection: null, // Conexión para contactos
    chatConnection: null, // Conexión para chats
    isSignalRDestroyed: false,
    chatStartSequence: 0,

    // carga de chat
    activeChat: {
      avatar: "/img/9.3fd39137.png",
    },
    chatInputMessage: "",
    loadingMoreMessages: false, // Para evitar múltiples peticiones al mismo tiempo
    allMessagesLoaded: false, // Para evitar nuevas peticiones si todos los mensajes ya están cargados
    idConversation: null,
    phoneNumber: null,
    phoneNumberSearch: null,
    currentPageMenssage: 1,
    perPageMenssage: 10,
    totalPagesMessage: 1,

    // carga de concersaciones
    contacts: [],
    listContacts: [],
    constentChat: {},
    currentPageContact: 1,
    perPageContact: 10,
    totalPagesContact: 2,
    allContactsLoaded: false,
    loadingContacts: false,
    contactsRefreshPending: false,
    loadingChat: false,
    chatReadState: {
      initializedAt: null,
      conversations: {},
    },
    // Auto-refresh interval
    contactsRefreshInterval: null,
    isRefreshingContacts: false,

    // Array para almacenar todos los timers activos
    activeTimers: [],

    // Message refresh state
    isRefreshingMessages: false,
    hasOlder: true,
    hasNewer: true,
    isLoading: false,
  }),

  setup() {
    const CHAT_APP_STORE_MODULE_NAME = "app-chat";

    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME))
      store.registerModule(CHAT_APP_STORE_MODULE_NAME, chatStoreModule);

    onUnmounted(() => {
      if (store.hasModule(CHAT_APP_STORE_MODULE_NAME))
        store.unregisterModule(CHAT_APP_STORE_MODULE_NAME);
    });

    const { resolveAvatarBadgeVariant } = useChat();

    // const sendMessage = () => {}
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
      suppressScrollX: true,
    };

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false);
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility();

    return {
      resolveAvatarBadgeVariant,
      // sendMessage,
      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,
      // UI
      perfectScrollbarSettings,
      // UI + SM Devices
      // startConversation,
      mqShallShowLeftSidebar,
    };
  },

  computed: {
    activeContactId() {
      // return this.activeChat.idConversation;
      return this.activeChat ? this.activeChat.idConversation : null;
    },
    sortedChatData() {
      const base = this.constentChat?.chat?.chat || [];
      const sorted = [...base].sort((a, b) => (a.ts || 0) - (b.ts || 0));
      return {
        ...this.constentChat,
        chat: {
          ...this.constentChat.chat,
          chat: sorted,
        },
      };
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.handleSignalRCompanyChange(guid);
    },
    phoneNumberSearch(newVal) {
      if (newVal) {
        this.phoneNumberSearch = newVal;
      }
    },
    // Watcher para detectar nuevos mensajes y manejar scroll automático
    "constentChat.chat.chat": {
      handler(newMessages, oldMessages) {
        if (
          newMessages &&
          oldMessages &&
          newMessages.length > oldMessages.length
        ) {
          // Nuevos mensajes detectados
          console.log(
            `Nuevos mensajes detectados: ${
              newMessages.length - oldMessages.length
            }`,
          );

          // Hacer scroll automático después de un breve delay para permitir el renderizado
          this.$nextTick(() => {
            const timer = setTimeout(() => {
              this.refreshChatMessagesAutomatically();
            }, 1000);
            this.activeTimers.push(timer);
          });
        }
      },
      deep: true,
    },
  },

  created() {
    this.profileUserDataMinimal = this.profileUserData =
      this.$store.state.appConfig.user;
  },

  async mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadChatReadState();
    await this.initializeSignalRConnections();

    // Inicia la actualización automática de contactos
    this.startContactsAutoRefresh();
  },

  methods: {
    async handleSignalRCompanyChange(guid) {
      if (guid === this.companyGuid) return;

      this.companyGuid = guid;
      this.loadChatReadState();
      this.contacts = [];
      this.listContacts = [];
      this.currentPageContact = 1;
      this.totalPagesContact = 1;
      this.allContactsLoaded = false;
      this.contactsRefreshPending = false;
      this.idConversation = null;
      this.phoneNumber = null;
      this.clearChat();

      await this.closeSignalRConnections();
      if (!this.isSignalRDestroyed && this.companyGuid) {
        await this.initializeSignalRConnections();
      }
    },

    async initializeSignalRConnections() {
      if (this.isSignalRDestroyed || !this.companyGuid) return;

      const connection = createSignalRConnection("conversationsHub");
      this.contactsConnection = connection;

      connection.onreconnected(() => {
        if (connection !== this.contactsConnection || this.isSignalRDestroyed)
          return;
        this.socketConversation();
      });
      connection.onclose(() => {
        if (connection !== this.contactsConnection || this.isSignalRDestroyed)
          return;
        this.reconnectConversation(connection);
      });

      await this.startConversation(connection);
    },

    // Método para cargar parámetros de contactos
    chargeParamContacts(page = this.currentPageContact) {
      let arrParams = [];
      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`page,${page}`);
      arrParams.push(`rows,${this.perPageContact}`);
      if (this.phoneNumberSearch !== "" && this.phoneNumberSearch !== null) {
        arrParams.push(`phoneNumber,${this.phoneNumberSearch}`);
      }

      return getParams(arrParams);
    },

    chatReadStorageKey() {
      const idUser = this.$store.state.appConfig.idUser || "anonymous";
      return this.companyGuid
        ? `sofia-chat-read:${idUser}:${this.companyGuid}`
        : null;
    },

    loadChatReadState() {
      const emptyState = {
        initializedAt: new Date().toISOString(),
        conversations: {},
      };
      const storageKey = this.chatReadStorageKey();
      if (!storageKey) {
        this.chatReadState = emptyState;
        return;
      }

      try {
        const savedState = JSON.parse(localStorage.getItem(storageKey));
        this.chatReadState = {
          initializedAt: savedState?.initializedAt || emptyState.initializedAt,
          conversations:
            savedState?.conversations &&
            typeof savedState.conversations === "object"
              ? savedState.conversations
              : {},
        };
        if (!savedState?.initializedAt) this.saveChatReadState();
      } catch (error) {
        console.warn("No se pudo recuperar el estado de lectura del chat:", error);
        this.chatReadState = emptyState;
        this.saveChatReadState();
      }
    },

    saveChatReadState() {
      const storageKey = this.chatReadStorageKey();
      if (!storageKey) return;

      try {
        localStorage.setItem(storageKey, JSON.stringify(this.chatReadState));
      } catch (error) {
        console.warn("No se pudo guardar el estado de lectura del chat:", error);
      }
    },

    chatTimestamp(value) {
      if (!value) return NaN;
      const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);
      return hasTimeZone
        ? moment(value).valueOf()
        : moment.utc(value).valueOf();
    },

    isConversationUnread(idConversation, date) {
      if (!idConversation || !date) return false;
      if (String(idConversation) === String(this.idConversation)) return false;

      const lastReadAt =
        this.chatReadState.conversations[String(idConversation)] ||
        this.chatReadState.initializedAt;
      const messageTime = this.chatTimestamp(date);
      const readTime = this.chatTimestamp(lastReadAt);
      return Number.isFinite(messageTime) && messageTime > readTime;
    },

    markConversationAsRead(idConversation, date = null) {
      if (!idConversation) return;

      const contactIndex = this.listContacts.findIndex(
        (contact) =>
          String(contact.idConversation) === String(idConversation),
      );
      const contact =
        contactIndex >= 0 ? this.listContacts[contactIndex] : null;
      const readAt = date || contact?.date || new Date().toISOString();
      const conversationKey = String(idConversation);
      const currentReadAt = this.chatReadState.conversations[conversationKey];

      if (
        !currentReadAt ||
        this.chatTimestamp(readAt) > this.chatTimestamp(currentReadAt)
      ) {
        this.$set(this.chatReadState.conversations, conversationKey, readAt);
        this.saveChatReadState();
      }

      if (contactIndex >= 0 && contact.hasUnread) {
        this.listContacts.splice(contactIndex, 1, {
          ...contact,
          hasUnread: false,
        });
        this.updateVisibleContacts();
      }
    },

    mapConversationContact(newContact, currentContact = {}) {
      const date = newContact.date || currentContact.date || null;
      return {
        ...currentContact,
        about: currentContact.about || "",
        avatar:
          newContact.urlProfilePhoto ||
          currentContact.avatar ||
          "/img/9.3fd39137.png",
        fullName: newContact.phoneNumber || currentContact.fullName,
        role: newContact.idConversation,
        status: currentContact.status || "offline",
        idConversation: newContact.idConversation,
        date,
        hasUnread: this.isConversationUnread(
          newContact.idConversation,
          date,
        ),
        chat: {
          ...(currentContact.chat || {}),
          id: newContact.idConversation,
          lastMessage: {
            ...(currentContact.chat?.lastMessage || {}),
            message: date,
            time: date,
          },
        },
      };
    },

    mergeConversationContacts(conversations = []) {
      conversations.forEach((newContact) => {
        if (
          String(newContact.idConversation) === String(this.idConversation) &&
          newContact.date
        ) {
          this.markConversationAsRead(
            newContact.idConversation,
            newContact.date,
          );
        }

        const existingIndex = this.listContacts.findIndex(
          (contact) => contact.idConversation === newContact.idConversation,
        );
        const currentContact =
          existingIndex >= 0 ? this.listContacts[existingIndex] : {};
        const mappedContact = this.mapConversationContact(
          newContact,
          currentContact,
        );

        if (existingIndex >= 0) {
          this.listContacts.splice(existingIndex, 1, mappedContact);
        } else {
          this.listContacts.push(mappedContact);
        }
      });
    },

    updateVisibleContacts() {
      const search = (this.phoneNumberSearch || "").trim();
      const filteredContacts = search
        ? this.listContacts.filter((contact) =>
            contact.fullName?.includes(search),
          )
        : this.listContacts;

      this.contacts = [...filteredContacts].sort((a, b) => {
        const dateA = new Date(a.date || 0).getTime();
        const dateB = new Date(b.date || 0).getTime();
        return dateB - dateA;
      });
    },

    syncConversationDateFromMessages(messages = []) {
      if (!this.idConversation || !Array.isArray(messages) || !messages.length)
        return;

      const latestTimestamp = messages.reduce((latest, message) => {
        if (!message?.timestamp) return latest;
        if (!latest) return message.timestamp;
        return new Date(message.timestamp) > new Date(latest)
          ? message.timestamp
          : latest;
      }, null);
      if (!latestTimestamp) return;

      this.markConversationAsRead(this.idConversation, latestTimestamp);

      const existingIndex = this.listContacts.findIndex(
        (contact) =>
          String(contact.idConversation) === String(this.idConversation),
      );
      if (existingIndex < 0) return;

      const currentContact = this.listContacts[existingIndex];
      if (
        currentContact.date &&
        new Date(currentContact.date) >= new Date(latestTimestamp)
      )
        return;

      const updatedContact = this.mapConversationContact(
        {
          idConversation: currentContact.idConversation,
          phoneNumber: currentContact.fullName,
          urlProfilePhoto: currentContact.avatar,
          date: latestTimestamp,
        },
        currentContact,
      );
      this.listContacts.splice(existingIndex, 1, updatedContact);
      this.updateVisibleContacts();
    },

    flushPendingContactsRefresh() {
      if (
        !this.contactsRefreshPending ||
        this.loadingContacts ||
        this.isRefreshingContacts ||
        this.isSignalRDestroyed ||
        !this.companyGuid
      )
        return;

      this.contactsRefreshPending = false;
      this.$nextTick(() => this.refreshContactsSilently({ page: 1 }));
    },

    // Método para cargar parámetros de mensajes de un contacto específico
    chargeParamMessages(phoneNumber = null, idConversation = null) {
      let arrParams = [];
      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`phoneNumber,${phoneNumber}`);
      arrParams.push(`idConversation,${idConversation}`);
      arrParams.push(`page,${this.currentPageMenssage}`);
      arrParams.push(`rows,${this.perPageMenssage}`);
      return getParams(arrParams);
    },

    // Inicia la conexión SignalR y se une al grupo de notificaciones de la empresa
    async startConversation(connection = this.contactsConnection) {
      if (
        !connection ||
        connection !== this.contactsConnection ||
        this.isSignalRDestroyed ||
        !this.companyGuid
      )
        return;

      if (
        connection.state === signalR.HubConnectionState.Connected ||
        connection.state === signalR.HubConnectionState.Connecting ||
        connection.state === signalR.HubConnectionState.Reconnecting
      )
        return;

      try {
        await connection.start();
        if (connection !== this.contactsConnection || this.isSignalRDestroyed) {
          await connection.stop();
          return;
        }
        console.log("Conexión SignalR iniciada correctamente");
        await this.socketConversation();
      } catch (error) {
        console.log("Error al iniciar la conexión SignalR:", error);
        this.reconnectConversation(connection);
      }
    },

    reconnectConversation(connection = this.contactsConnection) {
      if (
        !connection ||
        connection !== this.contactsConnection ||
        this.isSignalRDestroyed ||
        !this.companyGuid
      )
        return;

      console.log("Reintentando conexión SignalR de contactos en 5 segundos...");
      const timer = setTimeout(() => {
        if (connection === this.contactsConnection) {
          this.startConversation(connection);
        }
      }, 5000);
      this.activeTimers.push(timer);
    },

    // Método para unirse al grupo de la empresa y escuchar notificaciones
    async socketConversation() {
      try {
        const guidCompany = this.companyGuid;
        const connection = this.contactsConnection;
        if (
          !guidCompany ||
          !connection ||
          connection.state !== signalR.HubConnectionState.Connected
        )
          return;

        await connection.invoke("JoinGroup", guidCompany);
        if (connection !== this.contactsConnection || this.isSignalRDestroyed)
          return;

        connection.off("ReceiveNotification", this.handleContactNotification);
        connection.on("ReceiveNotification", this.handleContactNotification);
        this.getContacts();

        if (!this.chatConnection) this.startChat();
      } catch (error) {
        console.log("Error al unirse al grupo SignalR:", error);
      }
    },

    handleContactNotification(data) {
      console.log("ReceiveNotification recibida:", data);
      this.refreshContactsSilently({ page: 1 });
    },

    // methodo para obtener los contactos
    async getContacts(currentPageContact) {
      console.log("currentPageContact", currentPageContact);
      this.currentPageContact = currentPageContact ?? this.currentPageContact;
      if (this.loadingContacts) return;
      this.loadingContacts = true;

      const param = this.chargeParamContacts();
      await getConversations(param)
        .then((response) => {
          // stopLoading()
          const result = _.get(response, "data.items") ?? [];
          if (response.data !== null) {
            this.currentPageContact = response.data.currentPage;
            this.totalPagesContact = response.data.totalPages;
          }

          // After contacts are loaded, scroll to top
          const scrollContainer = document.querySelector(
            ".chat-user-list-wrapper",
          );
          if (scrollContainer) {
            // scrollContainer.scrollTop = scrollContainer.scrollTop - 200;
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
          }
          // Verifica si ya no hay más páginas
          if (this.currentPageContact >= this.totalPagesContact) {
            this.allContactsLoaded = true;
          }
          this.mergeConversationContacts(result);
          this.updateVisibleContacts();
          console.log("list contacts", this.contacts);
        })
        .catch((error) => {
          // stopLoading();
          console.error("Error al cargar contactos:", error);
        })
        .finally(() => {
          this.loadingContacts = false;
          this.flushPendingContactsRefresh();
        });
    },

    // Método para actualizar contactos sin afectar el chat activo
    async refreshContactsSilently({ page = 1 } = {}) {
      if (this.isRefreshingContacts || this.loadingContacts) {
        this.contactsRefreshPending = true;
        return;
      }

      this.isRefreshingContacts = true;
      console.log("Actualizando contactos silenciosamente...");

      try {
        const param = this.chargeParamContacts(page);
        const response = await getConversations(param);

        const result = _.get(response, "data.items") ?? [];
        if (response.data !== null) {
          this.totalPagesContact = response.data.totalPages;
        }

        // Preservar el chat activo actual
        const currentActiveChatId = this.idConversation;
        const currentActiveChat = this.activeChat;

        this.mergeConversationContacts(result);
        this.updateVisibleContacts();

        // Restaurar el chat activo si existía
        if (currentActiveChatId && currentActiveChat) {
          this.idConversation = currentActiveChatId;
          this.activeChat = currentActiveChat;
        }

        console.log(
          "Contactos actualizados silenciosamente:",
          this.contacts.length,
        );
      } catch (error) {
        console.error("Error al actualizar contactos silenciosamente:", error);
      } finally {
        this.isRefreshingContacts = false;
        this.flushPendingContactsRefresh();
      }
    },

    // Iniciar actualización automática de contactos
    startContactsAutoRefresh() {
      if (this.contactsRefreshInterval) {
        clearInterval(this.contactsRefreshInterval);
      }

      this.contactsRefreshInterval = setInterval(() => {
        this.refreshContactsSilently({ page: 1 });
      }, 5000); // Actualizar cada 5 segundos

      console.log(
        "Actualización automática de contactos iniciada (cada 5 segundos)",
      );
    },

    // Detener actualización automática de contactos
    stopContactsAutoRefresh() {
      if (this.contactsRefreshInterval) {
        clearInterval(this.contactsRefreshInterval);
        this.contactsRefreshInterval = null;
        console.log("Actualización automática de contactos detenida");
      }
    },

    // Pausar temporalmente la actualización automática
    pauseContactsAutoRefresh() {
      if (this.contactsRefreshInterval) {
        clearInterval(this.contactsRefreshInterval);
        this.contactsRefreshInterval = null;
        console.log(
          "Actualización automática de contactos pausada temporalmente",
        );
      }
    },

    // Reanudar la actualización automática
    resumeContactsAutoRefresh() {
      if (!this.contactsRefreshInterval) {
        this.startContactsAutoRefresh();
        console.log("Actualización automática de contactos reanudada");
      }
    },

    // Método para manejar la actividad del usuario
    handleUserActivity() {
      // Pausar la actualización automática temporalmente
      this.pauseContactsAutoRefresh();

      // Reanudar después de 10 segundos de inactividad
      const timer = setTimeout(() => {
        this.resumeContactsAutoRefresh();
      }, 10000);

      // Agregar el timer al array de timers activos
      this.activeTimers.push(timer);
    },

    clearChat() {
      this.constentChat = { chat: { chat: [] } };
      this.chatInputMessage = "";
      this.activeChat = {
        avatar: "/img/9.3fd39137.png",
      };
    },

    // Método para abrir el chat de un contacto específico
    async startChat() {
      const sequence = ++this.chatStartSequence;
      const previousConnection = this.chatConnection;
      this.chatConnection = null;

      if (previousConnection) {
        previousConnection.off(
          "ReceiveNotification",
          this.handleChatNotification,
        );
        try {
          await previousConnection.stop();
        } catch (error) {
          console.log("Error al cerrar la conexión SignalR de chats:", error);
        }
      }

      if (
        this.isSignalRDestroyed ||
        !this.companyGuid ||
        sequence !== this.chatStartSequence
      )
        return;

      const connection = createSignalRConnection("conversationsHub");
      this.chatConnection = connection;
      connection.onreconnected(() => {
        if (connection !== this.chatConnection || this.isSignalRDestroyed)
          return;
        this.socketChat();
      });
      connection.onclose(() => {
        if (connection !== this.chatConnection || this.isSignalRDestroyed)
          return;
        this.reconnectStartChat(connection);
      });

      try {
        await connection.start();
        if (connection !== this.chatConnection || this.isSignalRDestroyed) {
          await connection.stop();
          return;
        }
        console.log("Conexión CHAT SignalR iniciada correctamente");
        await this.socketChat();
      } catch (error) {
        console.log("Error al iniciar la conexión CHAT SignalR:", error);
        this.reconnectStartChat(connection);
      }
    },

    reconnectStartChat(connection = this.chatConnection) {
      if (
        !connection ||
        connection !== this.chatConnection ||
        this.isSignalRDestroyed ||
        !this.companyGuid
      )
        return;

      console.log("Reintentando conexión SignalR del chat en 5 segundos...");
      const timer = setTimeout(() => {
        if (connection === this.chatConnection) this.startChat();
      }, 5000);
      this.activeTimers.push(timer);
    },

    // Método para unirse al grupo de la empresa y escuchar notificaciones
    async socketChat() {
      try {
        console.log("socketChat", this.idConversation);
        const conversationIdString = this.idConversation;
        if (!this.chatConnection) return;
        if (
          this.chatConnection.state !== signalR.HubConnectionState.Connected
        ) {
          console.log(
            "La conexión no está lista, esperando para unirse al grupo de chat...",
          );
          await this.waitForConnection();
        }

        const connection = this.chatConnection;
        if (!conversationIdString || !connection) return;

        await connection.invoke("JoinGroup", conversationIdString);
        if (connection !== this.chatConnection || this.isSignalRDestroyed)
          return;

        console.log("Unido al grupo de chats:", conversationIdString);
        connection.off("ReceiveNotification", this.handleChatNotification);
        connection.on("ReceiveNotification", this.handleChatNotification);
      } catch (error) {
        console.log("Error al conectar al grupo de chat:", error);
      }
    },

    async handleChatNotification(data) {
      console.log("Chat -->", data);
      const match = String(data).match(/conversación (\d+)/);
      const conversationId = match?.[1] || null;
      if (conversationId && String(this.idConversation) === conversationId) {
        await this.refreshChatMessagesAutomatically();
      } else if (!conversationId) {
        console.log("No se pudo extraer el ID de la conversación.");
      }

      await this.refreshContactsSilently({ page: 1 });
    },

    waitForConnection() {
      return new Promise((resolve, reject) => {
        const startedAt = Date.now();
        const interval = setInterval(() => {
          if (
            this.chatConnection &&
            this.chatConnection.state === signalR.HubConnectionState.Connected
          ) {
            clearInterval(interval);
            resolve();
          } else if (
            this.isSignalRDestroyed ||
            !this.chatConnection ||
            Date.now() - startedAt >= 10000
          ) {
            clearInterval(interval);
            reject(
              new Error("La conexión del chat no estuvo disponible a tiempo"),
            );
          }
        }, 100);

        // Agregar el interval al array de timers activos
        this.activeTimers.push(interval);
      });
    },

    isMessageDuplicate(idConversationMessage) {
      return this.constentChat.chat.chat.some(
        (msg) => msg.idConversationMessage === idConversationMessage,
      );
    },

    async openChatOfContact(phoneNumber, idConversation, urlProfilePhoto) {
      console.log("Open chat");
      if (!idConversation || !phoneNumber) {
        console.log("No hay una conversación activa para refrescar.");
        return;
      }

      if (this.loadingChat) {
        return;
      }

      this.clearChat();
      this.currentPageMenssage = 1;
      this.loadingMoreMessages = false;
      this.allMessagesLoaded = false;

      // Limpiar estado de actualización automática
      this.isRefreshingMessages = false;

      this.idConversation = String(idConversation);
      this.phoneNumber = phoneNumber;
      this.markConversationAsRead(this.idConversation);
      this.chatInputMessage = "";
      this.activeChat = {
        fullName: phoneNumber,
        conversationId: this.idConversation,
        avatar: urlProfilePhoto ?? "/img/9.3fd39137.png",
      };
      console.log("Conversación activa:", this.activeChat);
      await this.startChat();

      const param = this.chargeParamMessages(
        this.phoneNumber,
        this.idConversation,
      );
      this.loadingChat = true;
      await getMessages(param)
        .then((response) => {
          if (!response.err) {
            // Actualiza el estado de los mensajes
            this.currentPageMenssage = response.data?.currentPage;
            this.totalPagesMessage = response.data?.totalPages;
            const result = _.get(response, "data.items") || [];
            this.loadingChat = false;
            this.syncConversationDateFromMessages(result);
            this.constentChat.chat.chat = result.map(this.normalizeMessage);
            console.log("constentChat", this.constentChat);
          }
        })
        .catch((error) => {
          console.log("Error al abrir el chat de contacto:", error);
          this.loadingChat = false;
        });
    },

    refreshChat() {
      if (!this.idConversation || !this.phoneNumber) {
        console.log("No hay una conversación activa para refrescar.");
        return;
      }

      this.clearChat();
      this.currentPageMenssage = 1;
      this.loadingMoreMessages = false;
      this.allMessagesLoaded = false;

      console.log(
        "hay una conversación activa para refrescar.",
        this.idConversation,
      );
      const param = this.chargeParamMessages(
        this.phoneNumber,
        this.idConversation,
      );

      return getMessages(param)
        .then((response) => {
          console.log("response", response);
          if (!response.err) {
            const result = _.get(response, "data.items") || [];
            // Actualiza el estado de los mensajes
            this.currentPageMenssage = response.data?.currentPage;
            this.totalPagesMessage = response.data?.totalPages;
            this.syncConversationDateFromMessages(result);
            this.constentChat.chat.chat = result.map(this.normalizeMessage);
            // Asegúrate de hacer scroll al final del chat
            this.$nextTick(() => {
              // this.scrollToBottomInChatLog();
            });
          }
        })
        .catch((error) => {
          console.error("Error al refrescar el chat:", error);
        });
    },
    // Método para enviar un mensaje al contacto activo
    async addMessage(message, image) {
      console.log(message);
      console.log(image);
      let urlFile = null;
      let params = getParams([`guidCompany,${this.companyGuid}`]);

      if (message == null || message == "") {
        this.alertToast(
          "danger",
          this.$t("pages.chat.alert"),
          this.$t("pages.chat.messageRequired"),
        );
        return;
      }

      if (image !== null && image !== "") {
        await postFile(image)
          .then((response) => {
            console.log(response);
            if (!response.err) {
              urlFile = response.data;
            }
          })
          .catch((er) => {
            console.log(er);
          });

        const dataImg = {
          idConversation: this.idConversation,
          message: {
            timestamp: new Date().toISOString(),
            content: message,
            urlMedia: urlFile,
          },
        };

        console.log(dataImg);
        await sendMessageImage(params, dataImg)
          .then(async (response) => {
            console.log(response);
            // stopLoading();
            this.chatInputMessage = "";
            await this.refreshChat();
            await this.refreshContactsSilently({ page: 1 });
          })
          .catch((error) => {
            // stopLoading();
            console.log("error", error);
          });
      } else {
        const dataText = {
          idConversation: this.idConversation,
          message: {
            timestamp: new Date().toISOString(),
            content: message,
          },
        };

        await sendMessage(params, dataText)
          .then(async (response) => {
            console.log(response);
            // stopLoading();
            this.chatInputMessage = "";
            await this.refreshChat();
            await this.refreshContactsSilently({ page: 1 });
          })
          .catch((error) => {
            // stopLoading();
            console.log("error", error);
          });
      }
    },

    scrollToBottomInChatLog() {
      nextTick(() => {
        const scrollEl =
          this.refChatLogPS?.$el?.querySelector(".ps__rail-y")?.parentElement;
        if (scrollEl) {
          scrollEl.scrollTop = scrollEl.scrollHeight;
        } else {
          console.log(
            "No se pudo encontrar el contenedor del scroll después de varios intentos.",
          );
        }
      });
    },

    // methodo para cargar más mensajes
    async loadNewerMessages(page) {
      console.log("Mensajes nuevos", page);
      if (this.idConversation == null || this.phoneNumber == null) {
        console.log("No hay una conversación activa para refrescar.");
        return;
      }
      if (this.loadingMoreMessages || this.allMessagesLoaded) return;
      this.loadingMoreMessages = true;

      try {
        this.currentPageMenssage = page;
        const param = this.chargeParamMessages(
          this.phoneNumber,
          this.idConversation,
        );
        const response = await getMessages(param);

        if (!response.err) {
          this.currentPageMenssage = response.data?.currentPage;
          this.totalPagesMessage = response.data?.totalPages;
          const result = _.get(response, "data.items") || [];

          if (result.length > 0) {
            // Filtrar y agregar mensajes válidos, evitando duplicados usando idConversationMessage
            console.log("loadMoreMessages:", result);
            const add = result.map(this.normalizeMessage);

            // Inserta solo los que no estén (por id)
            add.forEach((m) => {
              if (!this.isMessageDuplicate(m.idConversationMessage)) {
                // Da igual si haces unshift o push: el computed sortedChatData ordena
                this.constentChat.chat.chat.unshift(m);
              }
            });
          } else {
            this.allMessagesLoaded = true; // No hay más mensajes por cargar
          }
        }
      } catch (error) {
        console.log("Error al cargar más mensajes:", error);
      } finally {
        this.loadingMoreMessages = false;
      }
    },

    filterContacts(searchQuery) {
      this.phoneNumberSearch = searchQuery;
      console.log("searchQuery", this.phoneNumberSearch);
      this.getContacts(1);
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    // Método para refrescar automáticamente los mensajes del chat activo
    async refreshChatMessagesAutomatically() {
      if (!this.idConversation || !this.phoneNumber) {
        console.log("No hay una conversación activa para refrescar mensajes.");
        return;
      }

      try {
        console.log("Refrescando mensajes automáticamente...");
        this.isRefreshingMessages = true;

        // Obtener los mensajes más recientes
        const param = this.chargeParamMessages(
          this.phoneNumber,
          this.idConversation,
        );
        const response = await getMessages(param);

        if (!response.err) {
          this.currentPageMenssage = response.data?.currentPage;
          this.totalPagesMessage = response.data?.totalPages;

          const result = _.get(response, "data.items") || [];
          this.syncConversationDateFromMessages(result);
          const newMessages = result.map(this.normalizeMessage);

          // Verificar si hay mensajes nuevos comparando IDs únicos
          const currentMessages = this.constentChat.chat?.chat || [];
          const currentMessageIds = new Set(
            currentMessages.map((msg) => msg.idConversationMessage),
          );

          // Encontrar mensajes realmente nuevos
          const trulyNewMessages = newMessages.filter(
            (msg) => !currentMessageIds.has(msg.idConversationMessage),
          );

          if (trulyNewMessages.length > 0) {
            console.log(
              `Mensajes nuevos detectados: ${trulyNewMessages.length}`,
            );

            // Agregar solo los mensajes nuevos al final
            this.constentChat.chat.chat = [
              ...currentMessages,
              ...trulyNewMessages,
            ];

            // Hacer scroll automático al final solo si el usuario está cerca del final
            this.$nextTick(() => {
              this.autoScrollToBottomIfNearEnd();
            });

          } else {
            console.log("No hay mensajes nuevos para mostrar");
          }
        }
      } catch (error) {
        console.error("Error al refrescar mensajes automáticamente:", error);
      } finally {
        // Ocultar el indicador después de un breve delay para que sea visible
        const timer = setTimeout(() => {
          this.isRefreshingMessages = false;
        }, 1000);
        this.activeTimers.push(timer);
      }
    },

    // Método para hacer scroll automático solo si el usuario está cerca del final
    autoScrollToBottomIfNearEnd() {
      if (!this.$refs.refChatLogPS) return;

      const scrollEl =
        this.$refs.refChatLogPS.$el?.querySelector(
          ".ps__rail-y",
        )?.parentElement;
      if (!scrollEl) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollEl;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;

      // Solo hacer scroll automático si el usuario está cerca del final
      if (isNearBottom) {
        // this.scrollToBottomInChatLog();
        console.log("Scroll automático al final del chat ejecutado");
      } else {
        console.log(
          "Usuario no está cerca del final, no se ejecuta scroll automático",
        );
      }
    },

    normalizeMessage(msg) {
      // Epoch UTC para ordenar sin errores de formato/locales
      const ts = moment.utc(msg.timestamp).valueOf();

      return {
        senderId: msg.sender,
        message: msg.urlMedia !== null ? msg.urlMedia : msg.content,
        typeMessage: msg.urlMedia !== null ? "image" : "text",
        time: moment
          .utc(msg.timestamp)
          .tz("America/Caracas")
          .format("YYYY-MM-DD HH:mm:ss"),
        ts, // <-- clave para ordenar
        idConversation: msg.idConversation,
        idConversationMessage: msg.idConversationMessage,
      };
    },

    // Método para limpiar todos los timers activos
    clearAllTimers() {
      console.log(`Limpiando ${this.activeTimers.length} timers activos`);

      // Limpiar todos los timeouts
      this.activeTimers.forEach((timer) => {
        clearTimeout(timer);
        clearInterval(timer);
      });

      // Limpiar el array de timers
      this.activeTimers = [];

      // Limpiar también el interval de contactos si existe
      if (this.contactsRefreshInterval) {
        clearInterval(this.contactsRefreshInterval);
        this.contactsRefreshInterval = null;
      }
    },
    // Método para cerrar conexiones SignalR
    async closeSignalRConnections() {
      const contactsConnection = this.contactsConnection;
      const chatConnection = this.chatConnection;
      this.contactsConnection = null;
      this.chatConnection = null;
      this.chatStartSequence += 1;

      if (contactsConnection) {
        contactsConnection.off(
          "ReceiveNotification",
          this.handleContactNotification,
        );
      }
      if (chatConnection) {
        chatConnection.off("ReceiveNotification", this.handleChatNotification);
      }

      await Promise.all(
        [contactsConnection, chatConnection]
          .filter(Boolean)
          .map((connection) =>
            connection.stop().catch((error) => {
              console.log("Error cerrando conexión SignalR:", error);
            }),
          ),
      );
    },

    // Método para resetear datos del componente
    resetComponentData() {
      this.contacts = [];
      this.clearChat();
      this.idConversation = null;
      this.phoneNumber = null;
      this.activeChat = { avatar: "/img/9.3fd39137.png" };
      this.companyGuid = null;
      console.log("✅ Datos del componente reseteados");
    },
  },

  beforeDestroy() {
    console.log("BeforeDestroy Chat");

    try {
      this.isSignalRDestroyed = true;
      this.stopContactsAutoRefresh();

      // 1. Limpiar todos los timers
      this.clearAllTimers();

      // 2. Detener conexiones SignalR
      this.closeSignalRConnections();

      // 3. Limpiar datos
      this.resetComponentData();

      console.log("✅ Componente Chat destruido forzadamente");
    } catch (error) {
      console.error("❌ Error al destruir componente:", error);
    }
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
<style lang="scss">
.scroll-area-chat-log {
  position: relative;
  margin: auto;
  width: auto;
  height: 200px;
}
</style>
